import React from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '../lib/utils'

// Centered page-level spinner. Kept for transient short loads (auth
// gates, takeover boots) where a skeleton would over-promise structure
// we don't yet know.
export function PageLoader({ compact = false, color = 'orange', label }) {
  const colorClass = color === 'blue' ? 'text-blue-500' : 'text-app-primary-500'
  const padClass = compact ? 'py-12' : 'py-20'
  return (
    <div
      className={cn('flex justify-center', padClass)}
      role="status"
      aria-live="polite"
    >
      <Loader2 className={cn('w-8 h-8 animate-spin', colorClass)} />
      {label && <span className="sr-only">{label}</span>}
    </div>
  )
}
